export default __webpack_public_path__ + "static/media/logo-pocr.8c3325bc.png";